import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Dispatch, SetStateAction } from 'react'
import { UpdateStepData } from '@omnea-app/core/coreFrontendClient'
import { CoreHttpClient } from '@omnea-app/core/coreHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RequestStepsQueryKey } from '../../../useGetRequestSteps'

type MutationFnParams = {
  body: UpdateStepData
  setLoadingStep: Dispatch<SetStateAction<string | null>>
}

export const useUpdateStepData = ({ requestId }: { requestId: string }) => {
  const { getToken } = useAuthenticatedUser()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ body, setLoadingStep }: MutationFnParams) => {
      setLoadingStep(body.input.id)
      const authorization = await getToken()
      const coreApiClient = new CoreHttpClient({ authorization })
      const { data, error } = await coreApiClient.POST('/workflow-engine/step-data', {
        body,
      })
      setLoadingStep(null)
      throwIfApiError(error)
      return data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [RequestStepsQueryKey, requestId] })
    },
  })
}
